import axios from "axios";
import { BASEURL } from "./BASEURL";

export const handleAdminLogin = async (email, password) => {
  try {
    const res = await axios.post(`${BASEURL}/api/admin/admin-login`, {
      email,
      password,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const handleUsers = async (config) => {
  try {
    const res = await axios.get(`${BASEURL}/api/admin/user/users`, config);
    return res;
  } catch (error) {
    console.log(error);
  }
};
export const handleUsersWithNoWebsites = async (config) => {
  try {
    const res = await axios.get(
      `${BASEURL}/api/admin/user/users-with-nowebsites`,
      config
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};
export const handleUserWebsites = async (config) => {
  try {
    const res = await axios.get(
      `${BASEURL}/api/admin/user/user-websites`,
      config
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const handleChangePassword = async (
  id,
  OldPassword,
  NewPassword,
  config
) => {
  try {
    const res = await axios.post(
      `${BASEURL}/api/admin/user/change-password`,
      {
        id: id,
        OldPassword: OldPassword,
        NewPassword: NewPassword,
      },
      config
    );

    return res;
  } catch (error) {
    console.log(error);
  }
};

// forget password

export const handleforgotPassword = async (email) => {
  try {
    const res = await axios.post(`${BASEURL}/api/admin/user/foregt-password`, {
      email: email,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const handleResetPassword = async (token, password) => {
  try {
    const res = await axios.post(`${BASEURL}/api/admin/user/reset-password`, {
      token: token,
      password: password,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

// user subscriptions

export const handleUserSubscriptions = async (config) => {
  try {
    const res = await axios.get(
      `${BASEURL}/api/admin/user/user-subscriptions`,
      config
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const handleGetPricingPlans = async () => {
  try {
    const res = await axios.get(`${BASEURL}/api/admin/pricing/plans`);
    return res;
  } catch (error) {
    return error;
  }
};
export const handleUpdatePricingPlans = async (plansData) => {
  try {
    const res = await axios.post(`${BASEURL}/api/admin/pricing/update-plan`, {
      plansData,
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const handleGetSubscription = async (config, id) => {
  try {
    const res = await axios.get(
      `${BASEURL}/api/subscription/subscription/${id}`,
      config
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const handleUpdateSubscriptionStatus = async (config, id, status) => {
  try {
    const res = await axios.post(
      `${BASEURL}/api/subscription/update-subscription/${id}`,
      {
        status,
      },
      config
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const handleAddSubscription = async (
  subscription_plan_type,
  subscription_plan_period,
  subscription_start_date,
  subscription_end_date,
  OrderId,
  subscription_amount,
  createdBy,
  config
) => {
  try {
    const res = await axios.post(
      `${BASEURL}/api/subscription/add-subscription`,
      {
        subscription_plan_type,
        subscription_plan_period,
        subscription_start_date,
        subscription_end_date,
        OrderId,
        subscription_amount,
        createdBy,
      },
      config
    );
    return res;
  } catch (error) {
    return error;
  }
};

// create a stripe product

export const handleCreateStripeProduct = async (
  name,
  amount,
  currency,
  interval
) => {
  try {
    const res = await axios.post(
      `${BASEURL}/api/admin/pricing/create-stripe-product`,
      {
        name,
        amount,
        currency,
        interval,
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

// handle get stripe products

export const handleGetStripeProducts = async () => {
  try {
    const res = await axios.get(`${BASEURL}/api/admin/pricing/stripe-products`);
    return res;
  } catch (error) {
    return error;
  }
};

// handle Get user Subscriptions

export const handleGetUserSubscriptions = async (id) => {
  try {
    const res = await axios.get(
      `${BASEURL}/api/subscription/user-subscriptions/${id}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

// handle get subscription by id

export const handleGetSubscriptionById = async (id) => {
  try {
    const res = await axios.get(
      `${BASEURL}/api/subscription/user-subscription/${id}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

// handleUpdate subscription by id

export const handleUpdateSubscriptionById = async (status, id) => {
  try {
    const res = await axios.post(
      `${BASEURL}/api/subscription/update-subscription`,
      {
        status,
        id,
      }
    );
    return res;
  } catch (error) {
    return error;
  }
};

//  delte website by id

export const handleDeleteWebsite = async (email, website, config) => {
  try {
    const res = await axios.post(
      `${BASEURL}/api/website/delete-website`,
      {
        email,
        website,
      },
      config
    );
    return res;
  } catch (error) {
    return error;
  }
};
